import { createFileRoute } from '@tanstack/react-router'

import { MerchantUsersScreen } from './-components/merchant-users-screen.tsx'

export const Route = createFileRoute('/cs-tools/merchant-users')({
  component: MerchantUsersScreen
})
